import { OrderEnum } from 'shared/types/pagination-interface'

export const defaultPaginationOptions = {
  order: OrderEnum.next,
}
